"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _jsxRuntime = require("react/jsx-runtime");
const CloseButtonRoot = (0, _material.styled)(_IconButton.default)(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  padding: theme.spacing(1.4),
  margin: theme.spacing(2),
  background: 'rgba(255,255,255,.75)'
}));
const CloseButton = ({
  className,
  handleClick,
  variant,
  color
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(CloseButtonRoot, {
  variant: variant,
  color: color,
  className: className,
  onClick: handleClick,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
    fontSize: "small",
    color: "inherit"
  })
});
exports.CloseButton = CloseButton;
